// utility functions used by the preapproval list view and detail view
// to help us get human-readable values

// eslint-disable-next-line import/prefer-default-export
export function convertTimeFrame(timeframe): string {
  switch (timeframe) {
    case "now":
      return "ASAP";
    case "lt_90":
      return "1-3 months";
    case "lt_180":
      return "3-6 months";
    case "lt_360":
      return "6-12 months";
    case "gt_360":
      return "12+ months";
    default:
      return "Purchased time not defined";
  }
}
